import gql from "graphql-tag";

export const ADD_PAVING_FOREMAN = gql`
  mutation addPavingForeman($where: AddPavingForeman!){
    addPavingForeman(where: $where)
  }
`;